import { textStyles } from "./styles";

export default {
  styleOverrides: {
    label: {
      ...textStyles.textLabel,

      "&.Mui-disabled, &.Mui-completed": {
        ...textStyles.rightColumnCard,
      },
      "&.Mui-active": {
        // color: Colors.GREY500,
      },
    },
  },
};
